import { useEffect, useState } from 'react';
import { readWordDocument } from '@core/files';

/**
 * Документ Word прямо в приложении.
 *
 * Открывается одним касанием и без выхода наружу ([D-60](docs/DECISIONS.md)): раньше
 * `.docx` умел только уйти системным «Поделиться» в Word или Pages, а в заседании
 * на три касания и переключение приложений нет ни времени, ни свободной руки
 * ([CLIENT.md](docs/CLIENT.md), контекст 2).
 *
 * **Текст перетекает по ширине экрана, а не повторяет лист А4.** Это сознательно:
 * страница Word на экране в 390 точек читается только зумом, а юрист держит телефон
 * одной рукой. Кому нужно ровно как в Word — «Поделиться» осталось на своём месте
 * в шапке.
 */
export function WordView({ content, onFailed }: { content: Blob; onFailed: () => void }) {
  const [html, setHtml] = useState<string | null>(null);

  useEffect(() => {
    let dropped = false;

    void (async () => {
      const read = await readWordDocument(content);
      if (dropped) return;

      // Не прочли — экран говорит об этом словами и предлагает другое приложение.
      if (read === null) onFailed();
      else setHtml(read);
    })();

    return () => {
      dropped = true;
    };
  }, [content, onFailed]);

  if (html === null) return <div className="viewer__loading">Открываем документ…</div>;

  return (
    <div className="viewer__word">
      {/*
        Разметку строит библиотека из файла, который юристу прислал кто угодно,
        поэтому она проходит через фильтр `sanitizeWordHtml`: наружу выходит только
        разрешённый список тегов, собранный заново. Проверяется десятью тестами.
      */}
      <article className="viewer__word-page" dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
